// extracted by mini-css-extract-plugin
export default {"closeOverlay":"Overlay_closeOverlay__a1gCo","overlay":"Overlay_overlay__L2AlF"};